export const fieldClass =
  "mt-1.5 w-full rounded-md border border-[#c5d5c9] bg-white px-3 py-2.5 text-sm text-[#1c2430] placeholder:text-slate-400 focus:border-[#0B6A34] focus:outline-none focus:ring-2 focus:ring-[#0B6A34]/20";

export const labelClass = "block text-xs font-semibold uppercase tracking-wide text-[#5d6b62]";

export function Field({ label, className = "", children }) {
  return (
    <label className={`block ${className}`}>
      <span className={labelClass}>{label}</span>
      {children}
    </label>
  );
}

export function ChoiceButton({ selected, children, ...props }) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={`rounded-md border px-3 py-2 text-sm font-medium transition-colors ${
        selected
          ? "border-[#0B6A34] bg-[#0B6A34] text-white"
          : "border-[#c5d5c9] bg-white text-[#243028] hover:border-[#0B6A34]"
      }`}
      {...props}
    >
      {children}
    </button>
  );
}

export function Notice({ children }) {
  return (
    <div className="rounded-xl border border-[#b7d7be] bg-[#f3faf4] p-5 text-sm leading-relaxed text-[#1c4a2c]">
      {children}
    </div>
  );
}
